export const compaignArchieveData = [
  {
    name: "Distribution",
    type: "Public Relations",
    progress:
      "40.5% Opened\n \n  20.5% Closed\n \n  30.5% Unsubscribe\n \n  70.5% Delivered\n \n  35.0% Conversation",
    members: "3+",
    enable_sms:"on",
    startDate: "25 Sep 2023",
    endDate: "29 Sep 2023",
    status: "Success",
    created: "25 Sep 2023",
    Action: "Edit      Delete",
    key: "1"
  },
  {
    name: "Merchandising",
    type: "Content Marketing",
    progress:
      "65.5% Opened\n \n  83.5% Closed\n \n  67.5% Unsubscribe\n \n  32.0% Delivered\n \n  22.5% Conversation",
    members: "3+",
    startDate: "03 Oct 2023",
    endDate: "16 Oct 2023",
    status: "Pending",
    enable_sms:"off",
    created: "03 Oct 2023",
    Action: "Edit      Delete",
    key: "2"
  },
  {
    name: "Pricing",
    type: "Social Marketing",
    progress:
      "64.0% Opened\n \n  97.0% Closed\n \n  14.5% Unsubscribe\n \n  38.5% Delivered\n \n  53.0% Conversation",
    members: "3+",
    startDate: "17 Oct 2023",
    endDate: "28 Oct 2023",
    status: "Success",
    enable_sms:"on",
    created: "17 Oct 2023",
    Action: "Edit      Delete",
    key: "3"
  },
  {
    name: "Increased sales",
    type: "Brand",
    progress:
      "32.5% Opened\n \n  57.0% Closed\n \n  26.3% Unsubscribe\n \n  65.8% Delivered\n \n  17.4% Conversation",
    members: "3+",
    startDate: "07 Nov 2023",
    endDate: "14 Nov 2023",
    status: "Bounced",
    enable_sms:"on",
    created: "07 Nov 2023",
    Action: "Edit      Delete",
    key: "4"
  },
];
